"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIToggleFavoriteMetricResponseSchema = exports.APIToggleFavoriteMetricRequestSchema = exports.APIGetUserMetricResponseSchema = exports.APISetUserMetricResponseSchema = exports.APISetUserMetricRequestSchema = exports.USER_METRIC_ERROR_CODES = exports.MAX_FAVORITE_METRICS = void 0;
const zod_1 = require("zod");
// Constants for user metrics
exports.MAX_FAVORITE_METRICS = 5;
// Error codes for user metric operations
exports.USER_METRIC_ERROR_CODES = {
    MAX_FAVORITES_REACHED: 'MAX_FAVORITES_REACHED',
    METRIC_NOT_FOUND: 'METRIC_NOT_FOUND',
};
exports.APISetUserMetricRequestSchema = zod_1.z.object({
    metricIds: zod_1.z.array(zod_1.z.number()).min(1).max(exports.MAX_FAVORITE_METRICS),
});
exports.APISetUserMetricResponseSchema = zod_1.z.object({
    minScans: zod_1.z.number(),
    metrics: zod_1.z.array(zod_1.z.number()),
});
exports.APIGetUserMetricResponseSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
});
exports.APIToggleFavoriteMetricRequestSchema = zod_1.z.object({
    techName: zod_1.z.string(),
});
exports.APIToggleFavoriteMetricResponseSchema = zod_1.z.object({
    isFavorite: zod_1.z.boolean(),
    favoriteCount: zod_1.z.number(),
});
//# sourceMappingURL=user_metric.js.map